import React from 'react';
import { Typography } from '@mui/material';
import CommonButton from '..';
import { StyledButtonLabel } from './index.style';

const ButtonLabel = ({ label, error, helperText, ...rest }) => (
  <StyledButtonLabel>
    <Typography className="input-label">{label}</Typography>
    <CommonButton {...rest} />
    {error && <Typography className="input-error">{helperText}</Typography>}
  </StyledButtonLabel>
);

export default ButtonLabel;
